"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var color_1 = require("../utilities/color");
var game_area_1 = require("../utilities/game-area");
var i18next_1 = __importDefault(require("i18next"));
var LOADING_MIN_DURATION = 500;
var LOADING_RETRY_INTERVAL = 2000;
var LoadingState = /** @class */ (function (_super) {
    __extends(LoadingState, _super);
    function LoadingState(app, client) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._label = new PIXI.Text(i18next_1.default.t("loading"));
        _this._label.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
        _this._label.anchor.set(0.5);
        _this._label.style = {
            fontFamily: "Arial",
            fontWeight: "bold",
            fontSize: 35,
            fill: color_1.COLOR.WHITE
        };
        _this._elapsedTime = 0;
        _this._loaded = false;
        _this._retrying = false;
        return _this;
    }
    LoadingState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._label);
        this.startLoading();
        this._client.sendEvent("loading_entered");
    };
    LoadingState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._label);
    };
    LoadingState.prototype.update = function (deltaTime) {
        this._elapsedTime += deltaTime;
        if (this.shouldRetry()) {
            this._client.start();
            this._elapsedTime = 0;
            this._retrying = true;
        }
    };
    LoadingState.prototype.startLoading = function () {
        var _this = this;
        if (this._loaded) {
            return;
        }
        this._app.loader.load(function (loader, resources) {
            resources.ui.spritesheet.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
            _this._loaded = true;
        });
    };
    LoadingState.prototype.shouldRetry = function () {
        if (!this._loaded) {
            return false;
        }
        return this._elapsedTime > (this._retrying ? LOADING_RETRY_INTERVAL : LOADING_MIN_DURATION);
    };
    return LoadingState;
}(state_1.default));
exports.default = LoadingState;
